import { Cell, Grid } from 'bold-ui'
import { Form, TextField } from 'components/form'
import { EvolucoesOdontoInput } from 'graphql/types.generated'
import React from 'react'

export interface EvolucoesOdontoTableHeaderProps {
  filter: EvolucoesOdontoInput
  onChange(value: EvolucoesOdontoInput): void
}

export function EvolucoesOdontoTableHeader(props: EvolucoesOdontoTableHeaderProps) {
  const { filter, onChange } = props

  const handleChange = (query: string) => {
    onChange({ ...filter, query: query })
  }

  const renderFilterForm = () => {
    return (
      <>
        <Grid alignItems='flex-start' gap={1}>
          <Cell md={7} lg={6}>
            <TextField
              name='query'
              placeholder='Pesquise por procedimento, local ou profissional'
              icon='zoomOutline'
              onChange={(e) => handleChange(e.currentTarget.value)}
            />
          </Cell>
        </Grid>
      </>
    )
  }

  return <Form<EvolucoesOdontoInput> onSubmit={onChange} render={renderFilterForm} initialValues={filter} />
}
